import { render, staticRenderFns } from "./CardRelatorioParecerReferencial.vue?vue&type=template&id=2dc6ac28&scoped=true"
import script from "./CardRelatorioParecerReferencial.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardRelatorioParecerReferencial.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CardRelatorioParecerReferencial.vue?vue&type=style&index=0&id=2dc6ac28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc6ac28",
  null
  
)

export default component.exports